<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <app-content-header [contentHeader]="contentHeader"></app-content-header>
    </div>

    <!--desktop-->
    <div class="card" *ngIf="_utilService.isDesktop">
        <div class="card-title d-flex justify-content-between border-bottom mb-0 p-2">
            <div class="d-flex">
                <label for="search"></label>
                <input [(ngModel)]="searchKeyword" type="text" class="form-control w-fit" id="search"
                       [placeholder]="'SEARCH_NOTIFICATION'|translate" (keyup)="searchKeyword && searchKeyword.length > 3 ? filterCommunications() : null"/>
                <label for="category" class="d-flex align-items-center ml-1 mb-0">
                    <select id="category" [(ngModel)]="selectedCategory" class="form-control" (change)="filterCommunications()">
                        <option selected disabled value="all">{{'CATEGORY' | translate}}</option>
                        <option value="all">{{"ALL" | translate}}</option>
                        <option *ngFor="let category of categories">{{category.name}}</option>
                    </select>
                </label>
                <label for="status" class="d-flex align-items-center mb-0 ml-1">
                    <select id="status" [(ngModel)]="selectedStatus" class="form-control" (change)="filterCommunications()">
                        <option selected disabled value="all">{{'STATE' | translate}}</option>
                        <option value="all" selected>{{"ALL" | translate}}</option>
                        <option *ngFor="let state of _communicationService.statusList">{{state}}</option>
                    </select>
                </label>
            </div>
            <div class="d-flex">
                <label class="d-flex align-items-center ml-5 mb-0">{{"SHOW" | translate}}
                    <select [(ngModel)]="pageSize" class="form-control ml-075 pr-3">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                </label>
            </div>
        </div>
        <div class="card-body p-0">
            <div *ngIf="(filteredCommunication && filteredCommunication.length < 1 || filteredCommunication < 1) && isLoaded"
                 class="border-bottom communication">
                <h4 class="px-1 py-1 font-medium-1 font-weight-normal">{{"NOT_ONE_SCHEDULED_NOTIFICATION" | translate}}</h4>
            </div>
            <div class="border-bottom cursor-pointer py-1 communication"
                 *ngFor="let communication of filteredCommunication | slice: (pageBasicText-1) * pageSize : pageBasicText * pageSize"
                 (click)="modalOpen(openNotifcation, communication.id)">
                <div class="row px-2">
                    <div class="col-10">
                        <div class="d-flex align-items-center">
                            <h3 class="mb-025">{{communication.title}}</h3>
                            <div class="badge badge-light-primary profile-badge ml-1">
                                <small>{{communication.category_name}}</small>
                            </div>
                            <span class="badge badge-light-{{statusColor[communication.status]}} profile-badge ml-05">
                                <small>{{communication.statusLabel}}</small>
                            </span>
                        </div>
                        <div [innerHTML]="_utilService.stripHTML(communication.text)"
                             class="mt-025 text-break-line-1">
                        </div>
                    </div>
                    <div class="col-2 text-right">
                        <h6 class="text-end mt-05">{{communication.creator.complete_name || ("AUTOMATIC_NOTIFICATION" | translate)}}</h6>
                        <div>
                            <small class="text-end">{{_utilService.formatDate(communication.send_date, 'DD/MM/YYYY HH:mm:ss')}}</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--mobile - tablet-->
    <div class="container-fluid card border-bottom" *ngIf="_utilService.isMobile || _utilService.isTablet">
        <div class="row border-bottom py-1">
            <div class="col-12">
                <input [(ngModel)]="searchKeyword" type="text" class="form-control" id="search-mobile" [placeholder]="'SEARCH_NOTIFICATION'|translate"
                       (keyup)="searchKeyword && searchKeyword.length > 3 ? filterCommunications() : null"/>
            </div>
            <div class="col-6 mt-1">
                <select id="category-mobile" [(ngModel)]="selectedCategory" class="form-control" (change)="filterCommunications()">
                    <option selected disabled value="all">{{'CATEGORY' | translate}}</option>
                    <option value="all">{{"ALL" | translate}}</option>
                    <option *ngFor="let category of categories">{{category.name}}</option>
                </select>
            </div>
            <div class="col-6 my-1">
                <select id="status-mobile" [(ngModel)]="selectedStatus" class="form-control" (change)="filterCommunications()">
                    <option selected disabled value="all">{{'STATE' | translate}}</option>
                    <option value="all" selected>{{"ALL" | translate}}</option>
                    <option *ngFor="let state of _communicationService.statusList">{{state}}</option>
                </select>
            </div>
        </div>

        <!--body card-->
        <div *ngIf="(filteredCommunication.length < 1 || filteredCommunication < 1) && isLoaded"
             class="border-bottom py-1 communication">
            <h4 class="px-1 py-1 font-medium-1 font-weight-normal text-center">{{"NOT_ONE_SCHEDULED_NOTIFICATION" | translate}}</h4>
        </div>
        <div class="communication"
             *ngFor="let communication of filteredCommunication | slice: (pageBasicText-1) * pageSize : pageBasicText * pageSize"
             (click)="modalOpen(openNotifcation, communication.id)">
            <div class="row border-bottom p-1">
                <div class="col-12">
                    <h4 class="m-0">{{communication.title}}</h4>
                </div>
                <div class="col-12 mt-025">
                    <small [innerHTML]="_utilService.stripHTML(communication.text)" class="text-break-line-1"></small>
                </div>
                <div class="col-12 my-1">
                    <div class="d-flex align-items-center">
                        <div class="badge badge-light-primary profile-badge mr-1">
                            <small>{{communication.category_name}}</small>
                        </div>
                        <span class="badge badge-light-{{statusColor[communication.status]}} profile-badge">
                            <small>{{communication.statusLabel}}</small>
                        </span>
                    </div>
                </div>
                <div class="col-12">
                    <h6 class="m-0">{{communication.creator.complete_name || ("AUTOMATIC_NOTIFICATION" | translate)}}</h6>
                    <div>
                        <small>{{_utilService.formatDate(communication.send_date, 'DD/MM/YYYY HH:mm:ss')}}</small>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="d-flex" [ngClass.sm]="'justify-content-center'" [ngClass.lg]="'justify-content-end'" *ngIf="filteredCommunication && filteredCommunication.length > 0">
        <ngb-pagination [pageSize]="pageSize" [collectionSize]="filteredCommunication.length" [maxSize]="5"
                        [ellipses]="false" [(page)]="pageBasicText" aria-label="Custom pagination">
            <ng-template ngbPaginationPrevious>
                <span [data-feather]="'chevron-left'" [size]="'18'" [class]="'font-weight-bolder'"></span>
            </ng-template>
            <ng-template ngbPaginationNext>
                <span [data-feather]="'chevron-right'" [size]="'18'" [class]="'font-weight-bolder'"></span>
            </ng-template>
        </ngb-pagination>
    </div>
</div>


<!-- Modal -->
<ng-template #openNotifcation let-modal>
    <div class="modal-header">
        <div></div>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')"
                aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0">
        <div class="row">
            <div class="col-md-7 col-12">
                <h3 class="mb-05 p-0">{{selectedCommunication.title}}</h3>
                <span class="font-small-3 mr-05"
                      *ngIf="selectedCommunication.creator.complete_name">{{selectedCommunication.creator.complete_name}}</span>
                <span class="font-small-3 text-end">{{selectedCommunication.send_date.format('DD/MM/YYYY HH:mm:ss')}}</span>
            </div>
            <div class="col-md-5 col-12 text-right pl-0">
                <div class="badge badge-light-{{statusColor[selectedCommunication.status]}} profile-badge mb-05">
                    <small>{{selectedCommunication.statusLabel}}</small>
                </div>
                <br>
                <div class="badge badge-light-primary profile-badge">
                    <small>{{selectedCommunication.category_name}}</small></div>
                <div class="d-block mt-025">
                    <button *ngIf="today < selectedCommunication.send_date && _authenticationService.hasCapability('edit_notification')" (click)="modal.close()"
                            class="bg-transparent border-0 text-secondary pr-1"
                            [routerLink]="'/dashboard/edit-communication/'+selectedCommunication.id">
                        <i [data-feather]="'edit-2'" size="19"></i>
                    </button>
                    <button *ngIf="today < selectedCommunication.send_date && _authenticationService.hasCapability('delete_notification')"
                            (click)="deleteCommunication(selectedCommunication);modal.close()"
                            class="bg-transparent border-0 text-danger remove-item">
                        <i [data-feather]="'trash-2'" size="19"></i>
                    </button>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div style="word-wrap: break-word;hyphens: manual;" class="mt-3 mb-1 overflow-none"
                     [innerHTML]="transform(selectedCommunication.text)"></div>
            </div>
        </div>
        <div class="border-top" *ngIf="selectedCommunication.groups && selectedCommunication?.groups.length > 0">
            <div class="font-small-3 mt-1 mb-05">{{'NOTIFICATION_SENDED_TO_GROUPS' | translate}}</div>
            <span *ngFor="let group of selectedCommunication.groups"
                  class="font-small-4 font-weight-normal badge badge-light-primary mr-1 mb-1">{{group.name}}</span>
        </div>
        <div class="font-small-3 border-top pt-1">{{'NOTIFICATION_SENDED_TO_USERS' | translate}}</div>
        <div class="mb-05 mt-05" *ngFor="let recipients of selectedCommunication.users_list">
            <img #image (error)="image.hidden = true" height="24" width="24" class="round ng-star-inserted mr-05" src="{{recipients.user_avatar}}"
                 alt="user_avatar">
            <div class="avatar bg-light-primary avatar-sm mr-05" *ngIf="image.hidden">
                <div class="avatar-content font-small-1">{{ recipients.user_complete_name | initials }}</div>
            </div>
            <span class="font-small-3 mr-05">{{recipients.user_complete_name}}</span>
            <span class="badge badge-light-{{statusColor[recipients.status]}} profile-badge mr-05"
                  *ngIf="recipients.status!=3">
                <small>{{recipients.statusLabel}}</small>
            </span>
            <span class="badge badge-light-{{statusColor[recipients.status]}} profile-badge mr-05"
                  *ngIf="recipients.status==3" ngbTooltip="{{recipients.note}}">
                <small>{{recipients.statusLabel}}</small>
            </span>
        </div>
        <div class="mt-1">
            <button *ngIf="selectedCommunication?.users.length > 5 && selectedCommunication?.users_list.length < 6"
                    (click)="showMoreCommunicationUsers('more')" type="button"
                    class="btn btn-outline-primary btn-sm">{{"SHOW_ALL" | translate}}</button>
            <button *ngIf="selectedCommunication?.users_list.length > 5" (click)="showMoreCommunicationUsers('less')"
                    type="button"
                    class="btn btn-outline-primary btn-sm">{{"SHOW_LESS" | translate}}</button>
        </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
        <button (click)="modal.close()" type="button" class="btn btn-primary w-150" rippleEffect>
            {{"ALERT.BTN_CLOSE" | translate}}
        </button>
    </div>
</ng-template>
<!-- / Modal -->